// API base URL - always use relative paths since frontend is served from the same origin
export const getApiBaseUrl = () => {
  return '/api';
};

// Helper function to make API calls with proper URL
export const apiCall = async (endpoint, options = {}) => {
  const url = `/api${endpoint}`;

  // Add auth token if available
  const token = localStorage.getItem('token');
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(url, {
    ...options,
    headers
  });

  if (response.status === 401) {
    try {
      // Clear token and force login
      localStorage.removeItem('token');
    } catch (_e) {}
    if (window.location.pathname !== '/login') {
      window.location.replace('/login');
    }
    throw new Error('Unauthorized');
  }

  if (!response.ok) {
    throw new Error(`API call failed: ${response.status} ${response.statusText}`);
  }

  return response;
};
